import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import ContratoService from '../../../services/contrato'
import Contratado from './contratado';


const ListarContratados = () => {
    const [situacao, setSituacao] = useState("Ativo");
    const [contratados, setContratados] = useState([]);
    const [vazio, setVazio] = useState(false);

    async function fetchContratados() {
        var finalQuery = await preparaQuery();
        if (finalQuery === "") {
            // nada
        } else {
            var response = await ContratoService.buscar(finalQuery)
            if (response.data.length >= 1) {
                const uniqueContratados = [...new Map(response.data.map(item => [item['cnpj'], item])).values()];
                setContratados(uniqueContratados)
                setVazio(false)
            } else {
                setVazio(true)
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (situacao !== "false" && situacao !== "") prepQuery = prepQuery + `&situacao=${encodeURI(situacao)}`;
        return prepQuery;
    }


    useEffect(() => {
        fetchContratados();
    }, []);


    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setContratados={setContratados}
                    setVazio={setVazio}
                    fetchContratados={fetchContratados}
                    contratados={contratados}
                />
            </Fragment>

            <Fragment>
                <Alert variant='danger'>Nenhum contratado e/ou licitante foi sancionado administrativamente nos últimos 3 anos por essa Prefeitura.</Alert>
            </Fragment> :
                {/*<Fragment>
                    <Row xs={3}>
                        {contratados.map((contratado, index) =>
                            <Contratado
                                contratado={contratado}
                                key={index}
                            />
                        )}
                    </Row>
                </Fragment>*/}
        </Fragment>

    )
}

export default ListarContratados;